export const periodGroupsConfig = {
  open: { color: 'warning', label: 'Abertas' },
  approved: {
    color: 'primary',
    label: 'Aprovadas',
  },
  closed: { color: 'success', label: 'Fechadas' },
};
